import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CustomerViewAllTabsProps } from "./customer-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import CustomerViewDetails from "./customer-view-details/customer-view-details";
import CustomerViewAdditionalDetails from "./customer-view-additional-details/customer-view-additional-details";
import CustomerViewTimeline from "./customer-view-timeline/customer-view-timeline";
import CustomerViewDetailsViewAttachmentInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-attachment-info/customer-view-details-view-attachment-info";
import CustomerViewDetailsViewProductInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-product-info/customer-view-details-view-product-info";
import CustomerViewDetailsViewOpenActivitiesInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-open-activities-info/customer-view-details-view-open-activities-info";
import CustomerViewDetailsViewClosedActivitiesInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-closed-activities-info/customer-view-details-view-closed-activities-info";
import CustomerViewDetailsViewInvitedMeetingsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-invited-meetings-info/customer-view-details-view-invited-meetings-info";
import CustomerViewDetailsViewEmailInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-email-info/customer-view-details-view-email-info";
import CustomerViewDetailsViewCampaignsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-campaigns-info/customer-view-details-view-campaigns-info";
import "./customer-view.scss";
import { useLogin } from "../../../common/hooks/useUser";
import CustomerViewDetailsViewLeadsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-leads-info/campaign-view-details-view-leads-info";
import CustomerViewDetailsViewDocumentInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-documents-info/customer-view-details-view-document-info";

const CustomerViewDetailsAllTabs: React.FC<CustomerViewAllTabsProps> = ({
  customerDetails,
  selectedCustomerId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchCustomerDetails,
  leadId,
  onCustomerNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  disableCustomerStatus,
  permissions,
  setCrumbMappingOption,
  setViewTaskvalue,
  setViewMeetingvalue,
  setViewCallValue,
}) => {
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [indexValue, setIndexValue] = React.useState(0);
  const [updatedDate, setUpdatedDate] = useState<string | undefined>();
  const [disableEdit, setDisableEdit] = useState<boolean>(false);
  const { tenantDetails } = useLogin();

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIndexValue(newValue);
    setViewFullInfoOpen(false);
    setViewAddFullInfoOpen(false);
  };

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleFormSubmitError = (from?: any) => {
    if ("additionalDetails" === from) {
      setViewAddFullInfoOpen(true);
      setIndexValue(1);
      setAlertMessage(
        "Validation error in additional details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    } else {
      setViewFullInfoOpen(true);
      setIndexValue(0);
      setAlertMessage(
        "Validation error in details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    if (
      tenantDetails?.tenantType === "SuperTenant" &&
      customerDetails?.assigned_to &&
      customerDetails?.lead_status !== "Closed-Lost"
    ) {
      setDisableEdit(true);
    }
    else if (tenantDetails?.tenantType === "Tenant"
      && customerDetails?.lead_status === "Closed-Lost" 
      && customerDetails?.lead_source === "AFP"
    ) {
      setDisableEdit(true);
    }
    else setDisableEdit(false);
  }, [customerDetails]);

  return (
    <div className="leads-view-all-tabs">
      <div className="customer-list-view-tab-edit">
        <div className="customer-list-view-tab-section">
          <Box>
            <Tabs
              value={indexValue}
              onChange={handleMainTabChange}
              allowScrollButtonsMobile
              variant="scrollable"
            >
              <Tab label="Details" />
              <Tab label="Additional Details" />
              <Tab label="Attachments" />
               <Tab label="Documents" />
              <Tab label="Leads" />
              {/* <Tab label="Products" /> */}
              <Tab label="Activities" />
              {/* <Tab label="Open Activities" />
              <Tab label="Closed Activities" /> */}
              {/* <Tab label="Invited Meetings" /> */}
              <Tab label="Communications" />
              <Tab label="Campaigns" />
              <Tab label="Timeline" />
            </Tabs>
          </Box>
        </div>
      </div>
      <div>
        <CustomTabPanelComponent value={indexValue} index={0}>
          <CustomerViewDetails
            customerDetails={customerDetails}
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            viewFullInfoOpen={viewFullInfoOpen}
            setViewFullInfoOpen={setViewFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchCustomerDetails={fetchCustomerDetails}
            onCustomerNameUpdate={onCustomerNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            disableCustomerStatus={disableCustomerStatus}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={1}>
          <CustomerViewAdditionalDetails
            customerDetails={customerDetails}
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            viewFullInfoOpen={viewAddFullInfoOpen}
            setViewFullInfoOpen={setViewAddFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchCustomerDetails={fetchCustomerDetails}
            onCustomerNameUpdate={onCustomerNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={2}>
          <CustomerViewDetailsViewAttachmentInfo
            setLoading={setLoading}
            customerId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
           <CustomTabPanelComponent value={indexValue} index={3}>
          <CustomerViewDetailsViewDocumentInfo
            setLoading={setLoading}
            leadId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={4}>
          <CustomerViewDetailsViewLeadsInfo
           permissions={permissions}
           selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            />
            </CustomTabPanelComponent>
        {/* <CustomTabPanelComponent value={indexValue} index={3}>
          <CustomerViewDetailsViewProductInfo
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </CustomTabPanelComponent> */}
        <CustomTabPanelComponent value={indexValue} index={5}>
          <CustomerViewDetailsViewOpenActivitiesInfo
            // disableEdit={disableEdit || !permissions?.canWrite}
            customerDetails={customerDetails}
            setViewTaskvalue={setViewTaskvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            permissions={permissions}
            setViewMeetingvalue={setViewMeetingvalue}
            allLeadData={selectedCustomerId}
            setViewCallValue={setViewCallValue}
          />
        </CustomTabPanelComponent>
        {/* <CustomTabPanelComponent value={indexValue} index={4}>
          <CustomerViewDetailsViewClosedActivitiesInfo
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </CustomTabPanelComponent> */}
        {/* <CustomTabPanelComponent value={indexValue} index={6}>
          <CustomerViewDetailsViewInvitedMeetingsInfo disableEdit={disableEdit} />
        </CustomTabPanelComponent> */}
        <CustomTabPanelComponent value={indexValue} index={6}>
          <CustomerViewDetailsViewEmailInfo
            disableEdit={disableEdit || !permissions?.canWrite}
            customerDetails={customerDetails}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent
          value={indexValue}
          index={7}
          isCampaigns={true}
        >
          <CustomerViewDetailsViewCampaignsInfo
            allCustomerData={selectedCustomerId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={8}>
          <CustomerViewTimeline
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            setUpdatedDate={setUpdatedDate}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        </CustomTabPanelComponent>
      </div>
    </div>
  );
};

export default CustomerViewDetailsAllTabs;
